import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/CheckoutSuccess.css';

const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        <h1>Payment Cancelled</h1>
        <p>Your payment was cancelled. No charges have been made to your account.</p>
        <div className="button-group">
          <button className='retry-button' onClick={() => navigate('/checkout')}>Return to Checkout</button>
          <button className='continue-button' onClick={() => navigate('/merchandise')}>Continue Shopping</button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel; 